import React from 'react';
import PropTypes from 'prop-types';
import Money from '../lib/Money';

const TransactionReceipt = (props) => {
    const { tx } = props;

    const handlePrint = () => {
        const printContent = document.getElementById('receipt-content');
        const originalContent = document.body.innerHTML;

        // Create print-specific styles
        const printStyles = `
<style>
@media print {
    @page {
        margin: 0.5in;
        size: auto;
    }
    body { 
        margin: 0; 
        padding: 0; 
        font-family: 'Courier New', monospace;
        background: white;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        min-height: 100vh;
        padding-top: 20px;
    }
    .no-print { display: none !important; }
    .receipt-container {
        width: 320px !important;
        max-width: 320px !important;
        margin: 0 !important;
        padding: 20px 15px !important;
        background-color: #ffffff !important;
        border: 1px solid #ddd !important;
        box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
        font-family: 'Courier New', monospace !important;
        font-size: 12px !important;
        line-height: 1.2 !important;
        position: relative !important;
    }
}
</style>
`;

        // Replace body content with just the receipt for printing
        document.body.innerHTML = printStyles + printContent.outerHTML;

        // Print and restore original content
        window.print();
        document.body.innerHTML = originalContent;    

        // Re-attach event listeners by forcing a re-render
        window.location.reload();
    };

    return (
        <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100 bg-light py-4">
            <div className="receipt-container" id="receipt-content" style={{
                backgroundColor: '#ffffff',
                width: '320px',
                padding: '20px 15px',
                fontFamily: 'Courier New, monospace',
                fontSize: '12px',
                lineHeight: '1.2',
                border: '1px solid #ddd',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                position: 'relative'
            }}>
                {/* Perforated top edge */}
                <div style={{
                    position: 'absolute',
                    top: '-5px',
                    left: '0',
                    right: '0',
                    height: '10px',
                    background: 'repeating-linear-gradient(90deg, transparent, transparent 5px, #ddd 5px, #ddd 8px)',
                }}></div>

                {/* XRPScan Header */}
                <div className="text-center mb-3">
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#004a7c' }}>
                        XRPSCAN
                    </div>
                    <div style={{ fontSize: '10px', marginTop: '2px' }}>
                        XRPL Transaction Receipt
                    </div>
                </div>

                {/* Dotted separator */}
                <div style={{ 
                    borderTop: '1px dashed #666', 
                    margin: '10px 0',
                    width: '100%'
                }}></div>

                {/* Date and Time */}
                <div className="mb-2">
                    <div>Date: {new Date(tx?.date).toUTCString()}</div>
                </div>

                {/* Transaction Details */}
                <div className="mb-3">
                    <div style={{ textTransform: 'uppercase', fontWeight: 'bold', textAlign: 'center', margin: '10px 0' }}>
                        {tx?.TransactionType} TRANSACTION
                    </div>

                    <div className="mb-2">
                        <div style={{ fontWeight: 'bold' }}>TX HASH:</div>
                        <div style={{ fontSize: '9px', wordBreak: 'break-all' }}>
                            {tx?.hash}
                        </div>
                    </div>

                    {tx?.ctid &&
                    <div className="row" style={{ margin: '5px 0' }}>
                        <div className="col-4" style={{ padding: '0', fontSize: '10px' }}>CTID:</div>
                        <div className="col-8" style={{ padding: '0', fontSize: '9px', wordBreak: 'break-all', textAlign: 'left'  }}>
                            {tx?.ctid}
                        </div>
                    </div>
                    }

                    <div className="row" style={{ margin: '5px 0' }}>
                        <div className="col-4" style={{ padding: '0', fontSize: '10px' }}>FROM:</div>
                        <div className="col-8" style={{ padding: '0', fontSize: '9px', wordBreak: 'break-all', textAlign: 'left'  }}>
                            {tx?.Account}
                        </div>
                    </div>
                    {tx?.SourceTag >= 0 &&
                    <div className="row" style={{ margin: '5px 0' }}>
                        <div className="col-4" style={{ padding: '0', fontSize: '10px' }}>SRC TAG:</div>
                        <div className="col-8" style={{ padding: '0', fontSize: '9px', wordBreak: 'break-all', textAlign: 'left' }}>
                            {tx?.SourceTag}
                        </div>
                    </div>
                    }

                    <div className="row" style={{ margin: '5px 0' }}>
                        <div className="col-4" style={{ padding: '0', fontSize: '10px' }}>TO:</div>
                        <div className="col-8" style={{ padding: '0', fontSize: '9px', wordBreak: 'break-all', textAlign: 'left'  }}>
                            {tx?.Destination || "XRPL"}
                        </div>
                    </div>
                    {tx?.DestinationTag >= 0 &&
                    <div className="row" style={{ margin: '5px 0' }}>
                        <div className="col-4" style={{ padding: '0', fontSize: '10px' }}>DST TAG:</div>
                        <div className="col-8" style={{ padding: '0', fontSize: '9px', wordBreak: 'break-all', textAlign: 'left'  }}>
                            {tx?.DestinationTag}
                        </div>
                    </div>
                    }
                </div>

                {/* Dotted separator */}
                <div style={{ 
                    borderTop: '1px dashed #666', 
                    margin: '10px 0',
                    width: '100%'
                }}></div>

                {/* Amount Details */}
                <div className="mb-3">
                    {tx?.Amount?.value && tx?.Amount?.currency &&        
                    <div className="d-flex justify-content-between">
                        <span>AMOUNT:</span>
                        <span style={{ fontWeight: 'bold' }}>
                            {tx?.Amount?.currency === "XRP" &&
                                <Money value={tx?.Amount?.value} currency={tx?.Amount?.currency} drops />
                            }
                            {tx?.Amount?.currency !== "XRP" && tx?.Amount?.issuer &&
                                <Money value={tx?.Amount?.value} currency={tx?.Amount?.currency} />
                            }
                        </span>
                    </div>
                    }
                    {tx?.Fee >= 0 &&
                    <div className="d-flex justify-content-between">
                        <span>NETWORK FEE:</span>
                        <span>{tx?.Fee / 1000000} XRP</span>
                    </div>
                    }
                    <div style={{ 
                        borderTop: '1px solid #333', 
                        margin: '5px 0',
                        paddingTop: '5px'
                    }}>
                        {tx?.meta?.delivered_amount?.value && tx?.meta?.delivered_amount?.currency &&
                        <div className="d-flex justify-content-between" style={{ fontWeight: 'bold' }}>
                            <span>DELIVERED:</span>
                            <span>
                                {tx?.meta?.delivered_amount?.currency === "XRP" &&
                                    <Money value={tx?.meta?.delivered_amount?.value} currency={tx?.Amount?.currency} drops />
                                }
                                {tx?.meta?.delivered_amount?.currency !== "XRP" && tx?.meta?.delivered_amount?.issuer &&
                                    <Money value={tx?.meta?.delivered_amount?.value} currency={tx?.meta?.delivered_amount?.currency} />
                                }            
                            </span>
                        </div>
                        }
                    </div>
                </div>

                {tx?.meta?.TransactionResult !== 'tesSUCCESS' &&
                <div style={{ textTransform: 'uppercase', fontWeight: 'bold', textAlign: 'center', margin: '10px 0' }}>
                    FAILED {tx?.meta?.TransactionResult} 
                </div>
                }

                {/* Technical Details */}
                <div className="mb-3" style={{ fontSize: '10px' }}>
                    <div>Ledger Index: {tx?.ledger_index?.toLocaleString()}</div>
                    <div>Sequence: {tx?.Sequence}</div>
                    {tx?.meta?.TransactionResult === 'tesSUCCESS' &&
                        <div>Status: &#10003; VALIDATED</div>
                    }
                    {tx?.meta?.TransactionResult !== 'tesSUCCESS' &&
                        <div>Status: &#10005; FAILED</div>
                    }
                </div>

                {/* Dotted separator */}
                <div style={{ 
                    borderTop: '1px dashed #666', 
                    margin: '10px 0',
                    width: '100%'
                }}></div>

                {/* Footer */}
                <div className="text-center" style={{ fontSize: '10px' }}>
                    <div style={{ margin: '10px 0', fontWeight: 'bold' }}>
                        Thank you for using the XRPL!
                    </div>
                    <div>Transaction processed on</div>
                    <div>The XRP Ledger Public Network</div>
                </div>

                {/* QR Code Section */}
                <div className="text-center mb-3">
                    <div style={{ fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>
                        SCAN TO VIEW ON XRPSCAN.COM
                    </div>
                    <div className="d-flex justify-content-center">
                        <img 
                            src={`https://qr.xrpscan.workers.dev/?size=120&text=${encodeURIComponent(`https://xrpscan.com/tx/${tx?.ctid}`)}`}
                            alt="QR Code for transaction"
                            style={{
                                border: '1px solid #ddd',
                                padding: '5px',
                                backgroundColor: 'white'
                            }}
                        />
                    </div>
                    <div style={{ fontSize: '8px', marginTop: '5px' }}>
                        xrpscan.com/tx/{tx?.ctid}
                    </div>
                </div>

                {/* XRPScan branding at bottom */}
                <div className="text-center mt-3" style={{ 
                    fontSize: '8px', 
                    color: '#666',
                    borderTop: '1px solid #eee',
                    paddingTop: '10px'
                }}>
                    <div>XRPSCAN Explorer Services</div>
                    <div style={{ fontSize: '8px', marginTop: '15px' }}>
                        This receipt is for your records.
                    </div>
                    <div style={{ fontSize: '8px' }}>
                        Save the transaction hash for future reference.
                    </div>
                </div>

                {/* Print Button */}
                <div className="text-center mt-3 no-print">
                    <button 
                        className="btn btn-sm"
                        onClick={handlePrint}
                        style={{
                            backgroundColor: '#004a7c',
                            color: 'white',
                            border: 'none',
                            fontSize: '10px',
                            padding: '5px 12px',
                            borderRadius: '3px'
                        }}
                    >
                        <span role="img" aria-label='print'>🖨️</span> Print Receipt
                    </button>
                </div>

                {/* Perforated bottom edge */}
                <div style={{
                    position: 'absolute',
                    bottom: '-5px',
                    left: '0',
                    right: '0',
                    height: '10px',
                    background: 'repeating-linear-gradient(90deg, transparent, transparent 5px, #ddd 5px, #ddd 8px)',
                }}></div>
            </div>
        </div>
    );
}

TransactionReceipt.propTypes = {
    tx: PropTypes.object.isRequired,
}

export default TransactionReceipt;